import Icon from 'veui/components/Icon'

Icon.register({
  'layer-stack': {
    paths: [
      {
        d: 'M736 384a32 32 0 00-17.69-28.62L615.55 304l102.76-51.38a32 32 0 000-57.24l-320-160a32 32 0 00-28.62 0l-320 160a32 32 0 000 57.24L152.45 304 49.69 355.38a32 32 0 000 57.24L152.44 464 49.69 515.38a32 32 0 000 57.24l320 160a32 32 0 0028.62 0l320-160a32 32 0 000-57.24L615.55 464l102.76-51.38A32 32 0 00736 384zM384 99.78L632.45 224l-102.76 51.38L384 348.22l-145.55-72.77-.16-.08L135.55 224zm0 568.44L135.55 544 224 499.78l145.69 72.84a32 32 0 0028.62 0L544 499.78 632.45 544zm145.69-232.84L384 508.22l-145.69-72.84L135.55 384 224 339.78l145.62 72.81h.05a32 32 0 0028.62 0L544 339.78 632.45 384z'
      }
    ],
    width: '768',
    height: '768'
  }
})
